module.exports = __webpack_public_path__ + "img/avatar6.5f90039f.png";